import { memo } from 'react';
import styles from './OnboardingWorkflowToast.module.css';

interface OnboardingWorkflowToastProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

/** A toast line with one inline action (open the onboarding tab, retry). */
const OnboardingWorkflowToastBase = ({
  message,
  actionLabel,
  onAction,
}: OnboardingWorkflowToastProps) => (
  <span className={styles.body}>
    <span>{message}</span>
    <button type="button" className={styles.action} onClick={onAction}>
      {actionLabel}
    </button>
  </span>
);

export const OnboardingWorkflowToast = memo(OnboardingWorkflowToastBase);
